<div id="news" class="my-5">
    <div class="container-fluid px-2 px-lg-5">
        <div class="row">
            <div class="col-12" data-scroll>
                <h2 class="font-weight-bold text-center">Events</h2>
                <hr class=" p-1 " style="width: 160px;">
            </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="isLoading">
            <app-loader></app-loader>
        </div>
        <div *ngIf="!isLoading">
            <owl-carousel-o [options]="customOptions">

                <ng-container *ngFor="let event of news; let i=index">
                    <ng-template carouselSlide [id]="event.caption">
                        <div class="hero">
                            <a href="{{event.imgUrl}}" data-lightbox="news">
                                <img appLazyload class="hero-profile-img w-100" [src]="event.imgUrl"
                                    alt="{{event.caption}}">
                            </a>
                            <div class="hero-description-bk"></div>
                            <div class="hero-description">
                                <p>{{event.caption}}</p>
                            </div>
                            <div class="hero-btn">
                                <a href="{{event.subCategory}}" target="_blank">View Details <i
                                        class="fas fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>
        <div class="newsCarousel">
        </div>
    </div>
</div>